module.exports = __webpack_public_path__ + "img/search-banner.790cf601.png";